/* eslint-disable react/jsx-closing-tag-location,react/jsx-one-expression-per-line */
import React, { Component } from 'react'
import {
  Linking, ScrollView, Text, TouchableOpacity, View,
} from 'react-native'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { createStackNavigator } from '@react-navigation/stack'
import styles, { colors } from '../styles'
import textStyles from '../styles/text'
import * as RegionalLookup from './methods/RegionalContentLookUp'
import { isCountrySupported } from '../utils'
import GlobalCustomerSupportNumbersPopup from './subcomponents/GlobalCustomerSupportNumbersPopup'
import * as tapEvent from '../actions/tapEvents'
import NoMedicalAdviceFooter from './subcomponents/NoMedicalAdviceFooter'
import { logTapEvent } from '../actions/helpers'
import { backToGlobalOption } from '../navigators/NavigatorOptions'
import HyperLink from './subcomponents/Hyperlink'

const pkg = require('../../package.json')

class AboutAppPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: false,
    }
  }

  // eslint-disable-next-line class-methods-use-this
  callHelpHelper = async (number) => {
    await logTapEvent('CallHelp')
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(`dialPhone;${number}`)
    } else {
      try {
        await Linking.openURL(`tel:${number}`)
      } catch (e) {
        // console.error(e)
      }
    }
  }

  callHelp = async (number) => {
    try {
      setTimeout(async () => {
        await this.callHelpHelper(number)
      }, 1000)
    } catch (ex) {
      // console.log('callHelp exception: ', ex)
    }
  }

  handleOnPress = () => {
    logTapEvent('globalSupportNums')
    this.setState({ visible: true })
  }

  whichHyperlink() {
    const { locale, t, regionalContentLookup } = this.props
    const supportDetails = regionalContentLookup('callForSupportDetails')
    const supportInformation = regionalContentLookup('supportInformationSentenceKeys')

    if (isCountrySupported(locale)) {
      return (
        <HyperLink
          testID="questions-phone"
          linkStyle={styles.hyperlink}
          onPress={() => this.callHelp(supportDetails.callNumber)}
          beforeText={t(supportInformation.sentenceTwo, { hours: t(supportDetails.hoursSentence) })}
          linkText={supportDetails.phoneNumber}
          textStyle={textStyles.bodyContentText}
          style={{ flex: 1 }}
          accessibilityLabel={t('access:patientServicesCallLink')}
        />
      )
    }
    return (
      <HyperLink
        testID="show-global-support-numbers"
        accessibilityLabel={t('access:customerSupportCallLink')}
        linkText={t(supportDetails.callLatitudeSupport)}
        onPress={this.handleOnPress}
        textStyle={textStyles.bodyContentText}
        style={{ flex: 1 }}
      />
    )
  }

  patientSafetyClicked = () => {
    const { patientManualTapped, regionalContentLookup } = this.props

    const pageNumber = regionalContentLookup('manualPageNumbers').patientSafety
    if (pageNumber) {
      patientManualTapped('patientSafety')
    } else {
      const url = regionalContentLookup('patientSafetyLink')
      tapEvent.webViewTapped(url, 'patient-safety-info')
    }
  }

  render() {
    const { t, regionalContentLookup, appVersion } = this.props
    const { visible } = this.state
    const supportInformation = regionalContentLookup('supportInformationSentenceKeys')
    return (
      <View style={{ flex: 1, backgroundColor: colors.bscBlue }}>
        <ScrollView
          style={styles.whiteBackground}
          testID="scrollview-AboutThisApp"
          accessibilityLabel={t('access:aboutAppPage')}
        >
          <GlobalCustomerSupportNumbersPopup
            t={t}
            visible={visible}
            onHide={() => this.setState({ visible: false })}
          />
          <View style={[styles.container, styles.padding15]}>
            <View style={{ paddingTop: 15 }}>
              <View style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
                <Text style={[styles.textMargin, textStyles.bodyContentText]}>
                  {t(supportInformation.sentenceOne)}
                </Text>
                {this.whichHyperlink()}
              </View>
              <View style={[{
                borderBottomColor: colors.shark_grey50,
                borderBottomWidth: 1,
              }]}
              />
              <Text style={styles.aboutThisAppContentTextNoMargin}>
                {t('importantInfoTitle')}
              </Text>
              <Text style={[styles.textMargin, textStyles.bodyContentText]}>
                {t('appNotAReplacementForYourCommunicator')}
              </Text>
              {regionalContentLookup('manualURL') && (
              <TouchableOpacity
                onPress={() => this.patientSafetyClicked()}
                accessible
                accessibilityLabel={t('access:patientSafetyLink')}
                testID="patient-safety-info"
              >
                <View style={styles.button}>
                  <Text style={[styles.hyperlink, styles.textMargin, styles.linkText]} testID="patient-safety-info-text">
                    {t('patientSafetyInfo')}
                  </Text>
                </View>
              </TouchableOpacity>
              )}
            </View>
            <View>
              <Text style={[{ marginTop: 20 }, styles.versionText]} testID="appVersion-number-display">
                {t('appVersion', { pkgVersion: appVersion })}
              </Text>
              <Text style={[{ marginTop: 5 }, styles.versionText]} testID="webVersion-number-display">
                {t('webVersion', { webVersion: pkg.version })}
              </Text>
            </View>
          </View>
        </ScrollView>
        <NoMedicalAdviceFooter testID="no-medical-advice-footer" t={t} />
      </View>
    )
  }
}
AboutAppPage.defaultProps = {
  locale: 'en_US',
  appVersion: null,
}

AboutAppPage.propTypes = {
  patientManualTapped: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  locale: PropTypes.string,
  regionalContentLookup: PropTypes.func.isRequired,
  appVersion: PropTypes.func,
}

const actionCreators = {
  patientManualTapped: tapEvent.patientManualTapped,
  regionalContentLookup: RegionalLookup.regionalContentLookup,
}

const mapStateToProps = (state) => {
  const { storedData } = state
  return {
    locale: storedData.locale,
    appVersion: storedData.appVersion,
  }
}

export const AboutAppPageComponent = AboutAppPage

const AboutAppPageObj = withTranslation(['aboutApp'])(connect(mapStateToProps, actionCreators)(AboutAppPage))

const Stack = createStackNavigator()

export default function Screen() {
  return (
    <Stack.Navigator initialRouteName="AboutAppPage">
      <Stack.Screen name="AboutAppPage" component={AboutAppPageObj} options={backToGlobalOption('AboutAppPage', false, 'common:aboutThisAppTitle', 'large')} />
    </Stack.Navigator>
  )
}
